import { c as _c } from "react/compiler-runtime";
import ExperienceCarousel from './components/ExperienceCarousel';
import ExperienceTitleBanner from './components/ExperienceTitleBanner';
import ExperiencePracticals from './components/ExperiencePracticals';
import BookingConditions from '@/components/modules/BookingConditions';
import ReviewsSection from '@/components/modules/ReviewsSection';
import { WITH_REVIEWS } from '@/constants/config';
const ExperiencePageContent = (t0) => {
    const $ = _c(14);
    const { experience } = t0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== experience) {
        t1 = <ExperienceCarousel experience={experience}/>;
        t2 = <ExperienceTitleBanner experience={experience}/>;
        t3 = <ExperiencePracticals experience={experience}/>;
        $[0] = experience;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    }
    else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== experience.cancellation) {
        t4 = <BookingConditions cancellation={experience.cancellation} innerClassName="pt-0 pb-4"/>;
        $[4] = experience.cancellation;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== experience) {
        t5 = WITH_REVIEWS ?
            <ReviewsSection entity={experience}/> : null;
        $[6] = experience;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    let t6;
    if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
        t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    return t6;
};
export default ExperiencePageContent;
